import Component from '@glimmer/component';

import { HdsTime } from '@hashicorp/design-system-components/components';
import type { HdsTimeSignature } from '@hashicorp/design-system-components/components/hds/time/index';

export default class Time extends Component<HdsTimeSignature> {
  <template>
    <HdsTime
      @date={{@date}}
      @startDate={{@startDate}}
      @endDate={{@endDate}}
      @display={{@display}}
      @hasTooltip={{@hasTooltip}}
      @isOpen={{@isOpen}}
      data-test-time-container
      data-test-time-format={{@display}}
      ...attributes
    />
  </template>
}
